import { SortConfig } from '@interfaces/sort-config.model';

const SORT_CONFIG = require('@components/+search/classes/search_sort.config.json');

export type SortFiltersState = SortConfig;

export const initialState: SortFiltersState = SORT_CONFIG;
